import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import BookADemoSection from "@pages/BookADemo/BookADemoSection"
import React from "react"

type Props = {}

const bookADemo = (props: Props) => {
	return (
		<>
			<HeadMeta
				meta={{
					author: "Dream Broker",
					description:
						"Let us walk you through Dream Broker Studio and #One",
					keywords: "book a demo",
					ogDescription:
						"Let us walk you through Dream Broker Studio and #One",
					ogImage: "/dreamBroker/DB_logo_RGB.png",
					ogTitle: "Dream Broker - Request a demo for our products",
					ogType: "WebPage",
					title: "Book a Demo | Dream Broker",
				}}
			/>
			<BookADemoSection />
		</>
	)
}

export default bookADemo
